import { render, staticRenderFns } from "./ResultsProblem.vue?vue&type=template&id=b7a2a71e&"
import script from "./ResultsProblem.vue?vue&type=script&lang=js&"
export * from "./ResultsProblem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports